import React from "react";
import { Tooltip } from "antd";
import moment from "moment";
import StatusTag from "../../../../../Common/components/StatusTag";
import { makeReasonArray } from "../../../utils";

const HistoryQCTableCell = ({
  record,
  dataIndex,
  qcFlagKey,
  qcType,
  ...antdProps
}) => {
  if (!record) {
    return <td {...antdProps} />; // eslint-disable-line
  }

  // Create tooltip for all cells
  const tooltipTitle = () => (
    <span>
      Genista ID:
      {" "}
      {record.genista_id}
      <br />
      WO:
      {" "}
      {record.workorder_id}
      <br />
      Report Sent:
      {" "}
      {record.report_sent_at
        ? moment(record.report_sent_at).format("MM/DD/YYYY, h:mm:ss a")
        : "-"}
    </span>
  );

  // Determine cell content
  let cellContent;
  if (qcFlagKey && dataIndex) {
    // For QC columns, show StatusTag with messages
    const result = record[qcFlagKey];
    const status = record[dataIndex];
    const reasons = makeReasonArray(status);

    cellContent = (
      <div className="MarkSampleQCModal__HistoryQCCell">
        <StatusTag result={result} type={qcType || "QC"} />
        <div className="MarkSampleQCModal__HistoryQCCellMessage">
          {reasons.length > 0 ? (
            reasons.map((reason, index) => (
              <div key={index}>{reason}</div>
            ))
          ) : (
            "-"
          )}
        </div>
      </div>
    );
  } else {
    // For non-QC columns, show the data as is
    cellContent = record[dataIndex];
  }

  return (
    <Tooltip placement="top" title={tooltipTitle}>
    <td {...antdProps}> {/* eslint-disable-line */}
      <div className="MarkSampleQCModal__HistoryCellContent">
        {cellContent}
      </div>
    </td>
    </Tooltip>
  );
};

export default HistoryQCTableCell;
